import React, {useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {register} from "../../../actions/register.js";
import {InputWithErrorMessage} from "../../forms/inputWithErrorMessage.js";
import {InputAdornment, IconButton} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { ToastContainer, toast } from 'react-toastify';


import {
    validateConfirmPassword,
    validateEmailAddress,
    validateFirstName,
    validateLastName,
    validatePassword,
    validatePhoneNumber,
    validateUserName
} from "./validation.js";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import {registerInfo} from "../../../actions/registerInfo.js";
import {logout} from "../../../middleware/auth/index.js";
import {getUser, setLoginScreenStatus} from "../../../helpers/index.js";
import {Navbar, Nav, Dropdown} from "react-bootstrap";
import styles from "../../routing/topNavLoggedOut/TopNavtopNavLoggedOut.module.scss";
import {AUTH_ERROR, REGISTER_ERROR, REGISTER_INFO_ERROR} from "../../../actions/types.js";
import {patientActivationHeadingText} from "../../../actions/patientActivationHeadingText";

const Register = () => {
    const [userName, setUserName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [userNameError, setUserNameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [activationHeadingText, setActivationHeadingText] = useState("");
    const [isDirty, setIsDirty] = useState(false);
    const {userActivityLogId, encString} = useParams();
    const {errorMessage} = useSelector(state => state.register);
    const {errorMessage: registerInfoErrorMessage} = useSelector(state => state.registerInfo);
    const [userMessage, setUserMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmShowPassword, setConfirmShowPassword] = useState(false);
    const [show, setShow] = useState(false);
    const [currentAccessToken, setCurrentAccessToken] = useState('');
    const [hideEmailAddressField, setHideEmailAddressField] = useState(false);
    const [textFieldsEnabled, setTextFieldsEnabled] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(showPassword);
    }
    const handleClickConfirmShowPassword = () => {
        setShowConfirmPassword(showConfirmPassword);
    }
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const handleMouseDownConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {isTemporaryOrbitAccessUser, accessToken} = useParams();

    useEffect(() => {
        if (userMessage) {
            toast.success(userMessage);
        }

    }, [userMessage])

    useEffect(() => {
        if (errorMessage || registerInfoErrorMessage) {
            toast.error(registerInfoErrorMessage ? registerInfoErrorMessage : errorMessage)
        }

    }, [registerInfoErrorMessage, errorMessage])

    useEffect(async () => {
        dispatch({
            type: REGISTER_ERROR,
            payload: ''
        });

        dispatch({
            type: REGISTER_INFO_ERROR,
            payload: ''
        });

        if (Boolean(isTemporaryOrbitAccessUser ? isTemporaryOrbitAccessUser : false))
            setShow(isTemporaryOrbitAccessUser);

        setCurrentAccessToken(accessToken);

        if (!encString || encString.length === 0) {
            const ca = await registerInfo({id: userActivityLogId}, (data) => {
                setActivationHeadingText(data.activationHeadingText);
                setFirstName(data.firstName);
                setLastName(data.lastName);
                setUserName(data.emailAddress);
                setEmailAddress(data.emailAddress);

                setActivationHeadingText(data.activationHeadingText);

                if (data && data.firstName && data.lastName) {
                    setIsDirty(true);
                }
            });
            await dispatch(ca);
        }

        //get default orbit for logged in user
    }, []);

    useEffect(() => {
        if (encString && encString.length > 0)
            setTextFieldsEnabled(true);
        else
            setTextFieldsEnabled(false);
    }, [encString])

    const submitForm = async (e) => {
        e.preventDefault();
        dispatch({
            type: REGISTER_ERROR,
            payload: ''
        });

        dispatch({
            type: REGISTER_INFO_ERROR,
            payload: ''
        });

        if (!await validateAllFields())
            return;

        const registerUser = await register({
            userName,
            password,
            firstName,
            lastName,
            emailAddress: userName,
            userActivityLogId,
            encString
        }, () => {
            dispatch({
                type: 'RESET'
            });

            if (encString && encString.length > 0) {
                setUserMessage('Invitation Sent!  Please check your email and accept the invitation.');

                setTimeout(() => {
                    navigate('/');
                }, 3000);
            }
            setLoginScreenStatus(false);

            if (!encString || encString.length === 0)
                navigate("/");
        })
        await dispatch(registerUser);
    }

    const changeUserName = (e) => setUserName(e.target.value);
    const changePassword = (e) => setPassword(e.target.value);
    const changeFirstName = (e) => setFirstName(e.target.value);
    const changeLastName = (e) => setLastName(e.target.value);
    const changeConfirmPassword = (e) => setConfirmPassword(e.target.value);

    const validateUserNameField = async (e) => {
        await setIsDirty(true);
        await setUserNameError(validateUserName(userName, emailAddress));
    }

    const validatePasswordField = async (e) => {
        await setIsDirty(true);
        setConfirmPasswordError(validateConfirmPassword(password, confirmPassword));
        setPasswordError(validatePassword(password, confirmPassword));
    }

    const validateConfirmPasswordField = async (e) => {
        setConfirmPasswordError(validateConfirmPassword(password, confirmPassword));
        setPasswordError(validatePassword(password, confirmPassword));
    }

    const validateAllFields = async () => {
        await setIsDirty(true);
        let invalidFirstName = '';
        let invalidLastName = '';
        let invalidPassword = '';
        let invalidConfirmPassword = '';
        const invalidUserName = validateUserName(userName, emailAddress);

        if (!textFieldsEnabled) {
            invalidPassword = validatePassword(password, confirmPassword);
            invalidConfirmPassword = validateConfirmPassword(password, confirmPassword);
        }

        if (textFieldsEnabled) {
            invalidFirstName = validateFirstName(firstName);
            invalidLastName = validateLastName(lastName);
            setFirstNameError(invalidFirstName);
            setLastNameError(invalidLastName);
        }

        setUserNameError(invalidUserName);
        setPasswordError(invalidPassword);
        setConfirmPasswordError(invalidConfirmPassword);

        if (invalidUserName.length > 0 ||
            invalidPassword.length > 0 ||
            invalidFirstName.length > 0 ||
            invalidLastName.length > 0 ||
            invalidConfirmPassword.length > 0)
            return false;
        else
            return true;
    }

    return (
        <div className="w-100 gradient">
            <div className="w-100">
                <ToastContainer />
                <Container className="registration">
                    <div className="pageContainer">
                        {/*<div className="topContainer" style={{fontSize: '18px', marginTop: '36px'}}>*/}
                        <h1 className="text-center welcomeText text-dark">Welcome!
                            Let's get started.</h1>
                        <h1 className="text-center title headlineText" style={{width: "50%", wordWrap: "break-word"}}>
                        {activationHeadingText ? activationHeadingText : ''}</h1>
                        <Box className="material-box" component="form" onSubmit={submitForm} autoComplete="off">
                            <div className="card-body">
                                <div className="formFlexContainer">
                                    <div className="formInput">
                                        <InputWithErrorMessage errorMessage={userNameError}>
                                            <TextField className="w-100" name="Email Address" id="userName"
                                                       label="Email Address"
                                                       variant="outlined" value={userName} onChange={changeUserName}
                                                       onBlur={validateUserNameField}
                                                       error={!!userNameError} required/>
                                        </InputWithErrorMessage>
                                        {/*We need to populate the email address and not allow them to change*/}
                                    </div>
                                    <div className="formInput" style={{display: (!textFieldsEnabled ? 'block' : 'none')}}>
                                        <InputWithErrorMessage errorMessage={passwordError}>
                                            <TextField type={showPassword ? "text" : "password"} className="w-100"
                                                       name="password" id="password" label="Create a password (minimum 6 characters)"
                                                       variant="outlined" onChange={changePassword}
                                                       disabled={textFieldsEnabled}
                                                       autoComplete="new-password"
                                                       onKeyUp={validatePasswordField}
                                                       error={!!passwordError} required InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <a
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            style={{color: '#3399cc'}}

                                                        >
                                                            {showPassword ? 'hide' : 'show'}
                                                        </a>
                                                    </InputAdornment>
                                                )
                                            }}/>
                                        </InputWithErrorMessage>
                                    </div>
                                    <div className="formInput" style={{display: (!textFieldsEnabled ? 'block' : 'none')}}>
                                        <InputWithErrorMessage errorMessage={confirmPasswordError}>
                                            <TextField type={showConfirmPassword ? "text" : "password"}
                                                       className="w-100"
                                                       disabled={textFieldsEnabled}
                                                       name="password" id="password" label="Re-Enter Password"
                                                       variant="outlined" onChange={changeConfirmPassword}
                                                       onKeyUp={validateConfirmPasswordField}
                                                       error={!!confirmPasswordError}
                                                       required InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <a
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickConfirmShowPassword}
                                                            onMouseDown={handleMouseDownConfirmPassword}
                                                            style={{color: '#3399cc'}}
                                                        >
                                                            {showConfirmPassword ? 'hide' : 'show'}
                                                        </a>
                                                    </InputAdornment>
                                                )
                                            }}/>
                                        </InputWithErrorMessage>
                                    </div>
                                    <div className="inputSideBySide">
                                        <div className="formInput">

                                                <TextField className="w-100" name="First Name" id="lblFirstName"
                                                           label="First Name" disabled={textFieldsEnabled ? "" : "disabled"}
                                                           onBlur={() => {
                                                               if (textFieldsEnabled && textFieldsEnabled.length > 0)
                                                                   validateFirstName(firstName)
                                                           }}
                                                           variant="outlined" value={firstName} onChange={changeFirstName}
                                                           />

                                            {/*<div className="w-100 text-dark" id="lblFirstName">First Name</div>*/}
                                            {/*<div className="w-100 text-dark" id="firstName">{firstName}</div>*/}
                                        </div>
                                        <div className="formInput">

                                                <TextField className="w-100" name="Last Name" id="lblLastName"
                                                           label="Last Name" disabled={textFieldsEnabled ? "" : "disabled"}
                                                           onBlur={
                                                               () => {
                                                                   if (textFieldsEnabled && textFieldsEnabled.length > 0)
                                                                        validateLastName(lastName)
                                                               }
                                                           }
                                                           variant="outlined" value={lastName} onChange={changeLastName} />

                                            {/*<div className="w-100 text-dark" id="lblFirstName">Last Name</div>*/}
                                            {/*<div className="w-100 text-dark" id="firstName">{lastName}</div>*/}
                                        </div>
                                    </div>
                                    <div className="buttonContainer loginButtonContainer">
                                        <Button type="submit" variant="contained" className="loginUIComp center"
                                                disabled={userNameError.length > 0 || (textFieldsEnabled && (passwordError.length > 0 || confirmPasswordError.length > 0))}>
                                            {textFieldsEnabled ? 'Send me an invite' : 'Activate'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Box>
                        {/*</div>*/}
                    </div>
                </Container>
            </div>
            <div className="gradientBottom">
            </div>
        </div>

    )
};

export default Register;
